export interface PurchaseOrderMultiProductCreate {
  id: string;
  purchaseOrderHeaderId: string;
  purchaseOrderLineId: string;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  productTypeDescription: string;
  sequence: number;
  quantity: number;
  unitOfMeasure: string;
  price: number;
  deliveryDate: Date;
  selected: boolean;
  sellingCompany: string;
}
